import t from "./breakpoints.js";
const e = {
  ".mask-motion-appear": {
    opacity: 0
  },
  ".mask-motion-enter": {
    opacity: 0
  },
  ".mask-motion-leave": {
    opacity: 1
  },
  ".mask-motion-leave-active, .mask-motion-appear-active, .mask-motion-enter-active": {
    opacity: 1,
    transition: "all 0.3s"
  },
  ".panel-motion-left-appear-start, .panel-motion-left-enter-start, .panel-motion-left-leave-start": {
    transition: "none !important"
  },
  ".panel-motion-left-appear, .panel-motion-left-enter": {
    transform: "translateX(-100%)"
  },
  ".panel-motion-left-leave": {
    transform: "translateX(0)"
  },
  ".panel-motion-left-leave-active, .panel-motion-left-appear-active, .panel-motion-left-enter-active": {
    transform: "translateX(0)",
    transition: "all 0.3s"
  },
  ".panel-motion-right-appear-start, .panel-motion-right-enter-start, .panel-motion-right-leave-start": {
    transition: "none !important;"
  },
  ".panel-motion-right-appear, .panel-motion-right-enter": {
    transform: "translateX(100%)"
  },
  ".panel-motion-right-leave": {
    transform: "translateX(0)"
  },
  ".panel-motion-right-leave-active, .panel-motion-right-appear-active, .panel-motion-right-enter-active": {
    transform: "translateX(0)",
    transition: "all 0.3s"
  },
  ".rc-drawer": {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: "fixed",
    zIndex: 1050,
    pointerEvents: "none"
  },
  ".rc-drawer .chakra-portal": {
    height: "100%"
  },
  ".rc-drawer-inline": {
    position: "absolute"
  },
  ".rc-drawer-mask": {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: "absolute",
    zIndex: 1050,
    background: "rgba(0, 0, 0, 0.5)",
    pointerEvents: "auto"
  },
  ".rc-drawer-content-wrapper": {
    position: "absolute",
    zIndex: 1050,
    overflow: "hidden",
    transition: "transform 0.3s"
  },
  [`@media (max-width: ${t.xsm})`]: {
    ".rc-drawer-content-wrapper": {
      width: "100% !important"
    }
  },
  ".rc-drawer-content-wrapper-hidden": {
    display: "none"
  },
  ".rc-drawer-left .rc-drawer-content-wrapper": {
    top: 0,
    bottom: 0,
    left: 0
  },
  ".rc-drawer-right .rc-drawer-content-wrapper": {
    top: 0,
    right: 0,
    bottom: 0
  },
  ".rc-drawer-content": {
    width: "100%",
    height: "100%",
    background: "#fff",
    pointerEvents: "auto"
  },
  ".rc-drawer-content > div": {
    height: "100%"
  },
  ".panel-motion-right-leave-active": {
    transform: "translateX(100%) !important",
    transition: "all 0.3s"
  },
  ".panel-motion-left-leave-active": {
    transform: "translateX(-100%) !important",
    transition: "all 0.3s"
  },
  ".mask-motion-leave-active": {
    opacity: 0,
    transition: "all 0.3s"
  }
};
export {
  e as default
};
